import React from "react"

export const DownArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      width="18"
      height="18"
    >
      <path
        fill="#fffdba"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.0303 8.21967C13.3232 8.51256 13.3232 8.98744 13.0303 9.28033L8.78033 13.5303C8.48744 13.8232 8.01256 13.8232 7.71967 13.5303L3.46967 9.28033C3.17678 8.98744 3.17678 8.51256 3.46967 8.21967C3.76256 7.92678 4.23744 7.92678 4.53033 8.21967L7.5 11.1893L7.5 3.75C7.5 3.33579 7.83579 3 8.25 3C8.66421 3 9 3.33579 9 3.75L9 11.1893L11.9697 8.21967C12.2626 7.92678 12.7374 7.92678 13.0303 8.21967Z"
      ></path>
    </svg>
  )
}
